import { MapPin } from "lucide-react";
import ViewMgtDevicePanel from "../ViewMgtDevicePanel";
import { ViewMgtDeviceStatusValue } from "./ViewMgtDeviceStatusValue";

export default function ViewMgtDeviceStatusLocation({ device }: { deviceId?: string | null | undefined, device?: any | undefined | null }) {

  const lastLocation = device?.LastValidLocationUpdateLog?.location;
  const timestamp = device?.LastValidLocationUpdateLog?.logTimestamp;
  
  return (
    <ViewMgtDevicePanel title="Location" icon={<MapPin size={16} />}>
      <div className="grid grid-cols-1 gap-0">

        <ViewMgtDeviceStatusValue 
          label="Latitude"
          value={`${lastLocation?.latLng?.latitudeDeg?.toFixed(7)}°`}
          color="text-slate-500"
          timestamp={timestamp}
        />

        <ViewMgtDeviceStatusValue 
          label="Longitude"
          value={`${lastLocation?.latLng?.longitudeDeg?.toFixed(7)}°`}
          color="text-slate-500"
          timestamp={timestamp}
        />

        <ViewMgtDeviceStatusValue 
          label="Altitude"
          value={lastLocation?.latLng?.altitudeMetre ? `${lastLocation?.latLng?.altitudeMetre?.toFixed(7)} meters` : undefined}
          color="text-slate-500"
          timestamp={timestamp}
        />

        <ViewMgtDeviceStatusValue 
          label="Accuracy"
          value={lastLocation?.accuracyMetre ? `${lastLocation?.accuracyMetre.toFixed(3)} meters` : undefined}
          color="text-slate-500"
          timestamp={timestamp}
        />

        <ViewMgtDeviceStatusValue 
          label="Speed"
          value={lastLocation?.speedMetrePerSecond ? `${(lastLocation?.speedMetrePerSecond * 3.6).toFixed(3)} km/h` : undefined}
          color="text-slate-500"
          timestamp={timestamp}
        />

      </div>
    </ViewMgtDevicePanel>
  );
}
